import { render, staticRenderFns } from "./CCol.vue?vue&type=template&id=671c9be7&"
import script from "./CCol.vue?vue&type=script&lang=ts&"
export * from "./CCol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports